// generated file — do not edit by hand
export const APP_VERSION = '1.9.11';
